<template>
  <horizontal-bar-item-main-page>
    <template #mainContent>
      <div id="clubList">
        <!-- Concierge shortcut (Virtus demo) — text us instead of using the filters -->
        <div
          v-if="homeClubId === 613"
          class="mx-auto my-4 max-w-5xl px-4 md:px-0"
        >
          <div class="v-card flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
            <div class="flex items-start gap-4">
              <div class="border-secondary-500/50 hidden h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border sm:flex">
                <svg
                  class="h-5 w-5 text-secondary-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
              </div>
              <div>
                <div class="v-eyebrow">
                  Prefer not to search?
                </div>
                <div class="v-display mt-1 text-xl text-brand-500">
                  Let the concierge find your tee time.
                </div>
                <div class="mt-1 text-sm text-gray-500">
                  Send a quick text and we'll reply with a handful of ranked options.
                </div>
              </div>
            </div>
            <button
              type="button"
              class="inline-flex flex-shrink-0 items-center justify-center gap-3 bg-brand-500 px-7 py-3 text-[11px] font-semibold uppercase tracking-[0.28em] text-[#F5F1E8] transition hover:bg-brand-700"
              @click="showTextModal = true"
            >
              Send us a text
              <span class="h-px w-5 bg-secondary-500" />
              →
            </button>
          </div>
        </div>

        <SendTextModal
          v-if="showTextModal"
          @close="showTextModal = false"
        />

        <div class="relative mx-auto max-w-5xl overflow-hidden">
          <div
            v-local-img-bg="'url(cover.jpg)'"
            class="h-64 w-full min-w-full bg-cover bg-center md:hidden xxl:h-96"
          />
          <div class="m-4 -mt-12 items-start md:m-0 md:flex">
            <div
              class="z-30 mb-4 w-full overflow-hidden rounded-lg border bg-white sm:mr-4 md:m-0 md:w-3/12"
            >
              <div
                class="p-3"
                :class="$isStandard ? '' : 'pt-2'"
              >
                <!-- <div class="mb-2 text-gray-800 text-center">Refine Results</div> -->
                <div
                  v-if="$isStandard"
                  class="mb-1 flex items-center"
                >
                  <div>
                    <div class="flex">
                      <div class="h-2 w-2" />
                      <div class="h-2 w-2 bg-green-600" />
                      <div class="h-2 w-2" />
                    </div>
                    <div class="flex">
                      <div class="h-2 w-2 bg-green-600" />
                      <div class="h-2 w-2 bg-green-100" />
                      <div class="h-2 w-2 bg-green-700" />
                    </div>
                    <div class="flex">
                      <div class="h-2 w-2" />
                      <div class="h-2 w-2 bg-green-700" />
                      <div class="h-2 w-2" />
                    </div>
                  </div>
                  <div class="brand-heading ml-2 text-sm">
                    <div class="leading-none text-green-400">
                      Play<span class="text-green-600">More</span>Golf
                    </div>
                    <div class="leading-none text-gray-500">
                      Network
                    </div>
                  </div>
                </div>
                <div class="border-b pb-3 pt-2">
                  <input
                    v-model="search"
                    :disabled="isUsingLocation"
                    type="text"
                    :placeholder="placeholder"
                    class="block w-full rounded-lg bg-gray-100 p-2 px-3 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    @keyup.enter="unfocus()"
                  >

                  <div class="mt-2 flex select-none">
                    <div
                      class="flex h-10 w-4/12 cursor-pointer items-center justify-center rounded-lg rounded-r-none border border-r-0  py-3 text-center text-xs uppercase transition-all duration-200 focus:outline-none"
                      :class="
                        !searchTextIsLocation && !isUsingLocation
                          ? 'border-brand-500 bg-brand-500  text-white'
                          : 'text-gray-500 hover:text-secondary-500 bg-white border-gray-300'
                      "
                      @click="
                        latitude = 0;
                        longitude = 0;
                        searchTextIsLocation = false;
                      "
                    >
                      Name
                    </div>
                    <div
                      class="flex h-10 w-5/12 cursor-pointer items-center justify-center border py-3 text-center text-xs uppercase transition-all duration-200 focus:outline-none"
                      :class="
                        searchTextIsLocation && !isUsingLocation
                          ? 'border-brand-500 bg-brand-500  text-white'
                          : 'text-gray-500 hover:text-secondary-500 border-gray-300 bg-white '
                      "
                      @click="
                        latitude = 0;
                        longitude = 0;
                        searchTextIsLocation = true;
                      "
                    >
                      Location
                    </div>
                    <div
                      class="flex h-10 w-3/12 cursor-pointer items-center justify-center rounded-lg rounded-l-none border border-l-0  py-3 text-center text-xs uppercase transition-all duration-200 focus:outline-none"
                      :class="
                        isUsingLocation
                          ? 'border-brand-500 bg-brand-500  text-white'
                          : 'text-gray-500 hover:text-secondary-500 border-gray-300 bg-white'
                      "
                      @click="useLocation()"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        class="h-4 w-4 fill-current"
                      >
                        <path
                          d="M176 256C176 211.8 211.8 176 256 176C300.2 176 336 211.8 336 256C336 300.2 300.2 336 256 336C211.8 336 176 300.2 176 256zM256 0C273.7 0 288 14.33 288 32V66.65C368.4 80.14 431.9 143.6 445.3 224H480C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288H445.3C431.9 368.4 368.4 431.9 288 445.3V480C288 497.7 273.7 512 256 512C238.3 512 224 497.7 224 480V445.3C143.6 431.9 80.14 368.4 66.65 288H32C14.33 288 0 273.7 0 256C0 238.3 14.33 224 32 224H66.65C80.14 143.6 143.6 80.14 224 66.65V32C224 14.33 238.3 0 256 0zM128 256C128 326.7 185.3 384 256 384C326.7 384 384 326.7 384 256C384 185.3 326.7 128 256 128C185.3 128 128 185.3 128 256z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div v-if="showFiltersComputed">
                  <ExploreFilters
                    :filters="filters"
                    @toggleFacility="toggleFacility"
                  />
                </div>

                <div
                  v-if="!showFiltersComputed"
                  class="mt-4"
                >
                  <SecondaryButton
                    :text="'View Filters'"
                    @click="showFilters = true"
                  />
                </div>

                <div
                  v-else
                  class="mt-4"
                >
                  <SecondaryButton
                    v-if="$isMobile.value"
                    :text="'Hide Filters'"
                    @click="showFilters = false"
                  />
                  <PrimaryButton
                    :class="$isMobile.value ? 'mt-2' : ''"
                    :text="'Reset'"
                    @click="reset()"
                  />
                </div>
              </div>

              <div class="h-1 w-full bg-gradient-to-r from-brand-200 to-brand-500" />
            </div>

            <div class="w-full md:w-9/12 md:pl-4">
              <div class="w-full">
                <div class="relative z-20 mb-4 overflow-hidden rounded-lg border bg-white">
                  <div class="p-4">
                    <div
                      class="brand-heading items-center justify-between text-sm leading-none md:flex"
                      :class="currentView !== 'list' ? '' : 'mb-4 border-b pb-4'"
                    >
                      <div class="mb-3 flex select-none md:mb-0">
                        <div
                          class="flex h-10 w-1/2 cursor-pointer items-center justify-center rounded-lg rounded-r-none border border-r-0 p-3 text-center text-xs uppercase focus:outline-none md:w-20"

                          :class="
                            currentView === 'list'
                              ? 'border-brand-500 bg-brand-500  text-white'
                              : 'text-gray-500 hover:text-secondary-500 border-gray-300 bg-white'
                          "
                          @click="setCurrentView('list')"
                        >
                          List
                        </div>
                        <div
                          class="border-gray-30 flex h-10 w-1/2 cursor-pointer items-center justify-center rounded-lg rounded-l-none border border-l-0 p-3 text-center text-xs uppercase focus:outline-none md:w-20"
                          :class="
                            currentView === 'map'
                              ? 'border-brand-500 bg-brand-500  text-white'
                              : 'text-gray-500 hover:text-secondary-500 border-gray-300 bg-white'
                          "
                          @click="setCurrentView('map')"
                        >
                          Map
                        </div>
                      </div>

                      <div
                        v-if="currentView === 'list'"
                        class="items-center md:flex"
                      >
                        <div class="mb-1 mr-2 whitespace-nowrap leading-none text-gray-500 md:mb-0">
                          {{ $t('commonUi.sortBy') }}
                        </div>

                        <select
                          id="sortBy"
                          v-model="sortBy"
                          name="sortBy"
                          class="h-10 w-full cursor-pointer rounded-md border border-gray-300 bg-white p-2 text-sm focus:outline-none sm:text-sm"
                        >
                          <option value="0">
                            {{ $t('explore.clubList.sortBy.bestMatch') }}
                          </option>
                          <option value="1">
                            {{ $t('explore.clubList.sortBy.distance') }}
                          </option>
                          <option value="2">
                            {{ $t('explore.clubList.sortBy.alphabetically') }}
                          </option>
                          <option value="3">
                            {{ $t('explore.clubList.sortBy.avgPrice') }}
                          </option>
                          <option value="4">
                            {{ $t('explore.clubList.sortBy.favourites') }}
                          </option>
                          <option value="5">
                            {{ $t('explore.clubList.sortBy.lastBookingDate') }}
                          </option>
                          <option value="6">
                            {{ $t('explore.clubList.sortBy.roundsPlayed') }}
                          </option>
                          <option value="7">
                            {{ $t('explore.clubList.sortBy.newest') }}
                          </option>
                        </select>
                      </div>
                      <div
                        v-if="currentView === 'map'"
                        class="items-center md:flex"
                      >
                        <secondary-button
                          :text="!applyFiltersToMap ? ' Apply Filters' : 'See All Clubs'"
                          @click="applyFiltersToMap = !applyFiltersToMap"
                        />
                      </div>
                    </div>
                    <QuickSearches
                      v-if="currentView === 'list'"
                      :sort-by="sortBy"
                      @search="setQuickSearch"
                    />
                  </div>

                  <div class="h-1 w-full bg-gradient-to-r from-brand-200 to-brand-500" />
                </div>
              </div>
              <!-- Pinned home course (Virtus demo) — not in the fetched list -->
              <VirtusHomeClubCard
                v-if="showVirtusHome"
                class="mt-2"
              />
              <div
                v-if="!loading || addingMoreClubs"
                class="w-full"
              >
                <div v-if="clubs.length > 0 && currentView === 'list'">
                  <div
                    v-for="club in filteredList"
                    :key="club.Id"
                  >
                    <ClubCard
                      :club="club"
                      :is-home-club="club === homeClub"
                      :distances-are-bad="clubListHelper.distancesAreBad"
                      @navigate="navigate(club)"
                    />
                  </div>
                </div>
                <div
                  v-if="
                    currentView === 'list' &&
                      totalClubsInFilter > 0 &&
                      showingMaxClubs &&
                      !showingLiterallyAllClubs
                  "
                  class="flex w-full min-w-full justify-center py-8 text-center"
                >
                  <div class="flex max-w-lg justify-center">
                    <div>
                      <div class="brand-heading mt-3 inline-block pt-2 text-lg">
                        All filtered clubs being shown.
                      </div>
                      <div class="brand-body text-base text-gray-500">
                        To see more clubs, adjust or reset your current filters.
                      </div>

                      <div class="mt-4">
                        <SecondaryButton
                          text="Reset Filters"
                          @click="resetAndScroll"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="clubs.length === 0 && currentView === 'list'"
                  class="flex w-full min-w-full justify-center py-8 text-center"
                >
                  <div class="flex max-w-lg justify-center">
                    <div>
                      <div class="flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                          class="h-12 w-12 fill-current text-secondary-500"
                        >
                          <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                          <path
                            d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM347.9 394.5C353.7 401.2 363.8 401.9 370.5 396.1C377.2 390.3 377.9 380.2 372.1 373.5C349.8 347.9 311.1 320 256 320C200.9 320 162.2 347.9 139.9 373.5C134.1 380.2 134.8 390.3 141.5 396.1C148.2 401.9 158.3 401.2 164.1 394.5C182 373.8 212.6 352 256 352C299.4 352 329.1 373.8 347.9 394.5H347.9zM176.4 176C158.7 176 144.4 190.3 144.4 208C144.4 225.7 158.7 240 176.4 240C194 240 208.4 225.7 208.4 208C208.4 190.3 194 176 176.4 176zM336.4 240C354 240 368.4 225.7 368.4 208C368.4 190.3 354 176 336.4 176C318.7 176 304.4 190.3 304.4 208C304.4 225.7 318.7 240 336.4 240z"
                          />
                        </svg>
                      </div>
                      <div
                        class="brand-heading mt-3 inline-block border-t-4 border-gray-300 pt-2 text-lg"
                      >
                        No Clubs Found
                      </div>
                      <div class="brand-body text-base text-gray-500">
                        Sorry, we couldn't find any clubs based on your filters
                      </div>

                      <div class="mt-4">
                        <PrimaryButton
                          v-if="!searchTextIsLocation"
                          class="mb-2"
                          text="Did you want to search by location?"
                          @click="searchTextIsLocation = true"
                        />
                        <SecondaryButton
                          text="Reset Filters"
                          @click="reset()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="clubs.length > 0 && currentView === 'list' && !showingMaxClubs"
                  class="flex w-full min-w-full cursor-pointer select-none justify-center py-8 text-center"
                  @click="increaseIndex()"
                >
                  <div class="flex max-w-lg justify-center">
                    <div>
                      <div
                        class="brand-heading mt-3 inline-block border-t-4 border-gray-300 pt-2 text-lg"
                      >
                        Scroll Down For More
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loading && currentView === 'list'">
                <div
                  v-for="clubCardSkelIndex in 10"
                  :key="'clubCardSkel' + clubCardSkelIndex"
                >
                  <ClubCardSkeleton />
                </div>
              </div>
              <div v-if="mapClickedAtLeastOnce">
                <club-map
                  v-show="currentView === 'map'"
                  :additional-club-info="clubsForMap"
                  :only-show-clubs-with-additional-info="applyFiltersToMap"
                  :search-location="searchTextIsLocation && currentView === 'map' ? search : ''"
                  :latitude="currentView === 'map' && isUsingLocation ? latitude : 0"
                  :longitude="currentView === 'map' && isUsingLocation ? longitude : 0"
                  :loading-prop="currentView === 'map' && loading ? true : false"
                  class="mt-10"
                />
              </div>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div
            v-if="scrollPosition > 999 && !openSideMenu && ($isMobile.value || $isMobileApp)"
            :class="scrollPosition > 1000 ? 'opacity-100' : 'opacity-0'"
            class="fixed left-0 top-0 z-40 mt-16 w-full p-4 transition-all duration-500"
          >
            <PrimaryButton
              text="Back to top"
              @click="scrollTop()"
            />
          </div>
          <div
            v-if="scrollPosition > 999 && !openSideMenu && !$isMobile.value && !$isMobileApp"
            :class="scrollPosition > 1000 ? 'opacity-100' : 'opacity-0'"
            class="fixed bottom-16 left-32 z-40 py-4 transition-all duration-500"
          >
            <PrimaryButton
              :full-width-web="false"
              class="px-10"
              text="Back to top"
              @click="scrollTop()"
            />
          </div>
        </transition>
      </div>
    </template>
  </horizontal-bar-item-main-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';
import { ClubListSearchParametersModel } from 'pmg-services';
import ClubCardSkeleton from '@/app/shared/components/booking/clubCardSkeleton.vue';
import ClubMap from '@/app/shared/components/explore/clubMap.vue';
import HorizontalBarItemMainPage from '@/app/shared/components/layout/horizontalBarItemMainPage/horizontalBarItemMainPage.vue';
import { services } from '../../shared/services';
import ClubCard from '../../shared/components/booking/clubCard.vue';
import PrimaryButton from '../../shared/components/base/button/primaryButton.vue';
import SecondaryButton from '../../shared/components/base/button/secondaryButton.vue';
import QuickSearches from '../../shared/components/explore/quickSearches.vue';
import ExploreFilters from '../../shared/components/explore/exploreFilters.vue';
import SendTextModal from '../../shared/components/concierge/sendTextModal.vue';
import VirtusHomeClubCard from '../../shared/components/concierge/virtusHomeClubCard.vue';

export default {
  name: 'ExploreArea',

  components: {
    ClubCard,
    PrimaryButton,
    ClubCardSkeleton,
    QuickSearches,
    SecondaryButton,
    ClubMap,
    ExploreFilters,
    HorizontalBarItemMainPage,
    SendTextModal,
    VirtusHomeClubCard,
  },

  filters: {
    round(value, decimals) {
      let decimalValue = 0;
      let targetValue = 0;

      if (value > 0) {
        targetValue = value;
      }

      if (decimals > 0) {
        decimalValue = decimals;
      }

      /*eslint-disable */
      return Math.round(targetValue * Math.pow(10, decimalValue)) / Math.pow(10, decimalValue);
    },
  },

  data() {
    return {
      loading: true,
      locationLoading: false,
      endOfList: false,
      index: 10,
      showTextModal: false,
      scrollListenerAdded: false,
      scrollPosition: 0,
      showFilters: false,

      search: '',
      sortBy: '0',
      homeClub: null,
      clubs: [],
      latitude: "0",
      longitude: "0",
      watchID: null,
      location: false,
      clubListHelper: null,
      searchTextIsLocation: false,
      currentView: 'list',
      addingMoreClubs: false,

      filters: {
        distance: 100,
        maxAveragePrice: 10,
        minMaxRange: [0, 15],
        facilities: [
          { name: 'Driving Range', property: 'DrivingRange', enabled: false, },
          { name: 'Putting Green', property: 'PuttingGreen', enabled: false, },
          { name: 'Bar', property: 'Bar', enabled: false, },
          { name: 'Bar Food', property: 'BarFood', enabled: false, },
          { name: 'Coffee Shop', property: 'CoffeeShop', enabled: false, },
          { name: 'Restaurant', property: 'Restaurant', enabled: false, },
          { name: 'Gym', property: 'Gym', enabled: false, },
          { name: 'Pool', property: 'Pool', enabled: false, },
          { name: 'Free WiFi', property: 'FreeWiFi', enabled: false, },
        ]
      },

      mapClickedAtLeastOnce: false,
      clubsForMap: [],
      applyFiltersToMap: true,
    };
  },

  computed: {
    ...mapState({
      flexiPoints: state => state.user.flexiPoints,
      coverUrl: state => state.club.coverUrl,
      openSideMenu: state => state.layout.openSideMenu,
      homeClubId: state => state.user.homeClubId,
    }),

    showFiltersComputed() {
      return this.showFilters || !this.$isMobile.value;
    },

    hideQuickSearches() {
      return !(this.sortBy === '0' && this.search === '');
    },

    currentlyMapView() {
      return this.currentView === 'map';
    },

    showVirtusHome() {
      // Pin the Virtus home course above the fetched list (demo: it isn't returned by the API).
      if (Number(this.homeClubId) !== 613) return false;
      if (this.currentView !== 'list') return false;
      if (this.searchTextIsLocation) return false;
      const q = (this.search || '').trim().toLowerCase();
      if (!q) return true;
      return 'virtus golf'.indexOf(q) !== -1;
    },

    filteredList() {
      return this.clubs.filter(c => !c.ClosedToVisitors || c.Id === this.homeClubId);
    },

    playedCourses() {
      return this.clubs.filter(c => c.NumberOfBookings > 0)
    },

    ...mapGetters({
      currentTheme: 'getCurrentTheme',
      club: 'getClub',
    }),

    currentSearchParameters() {
      let searchParameters = new ClubListSearchParametersModel();
      searchParameters.numClubsToReturn = this.index;
      searchParameters.searchTerm = this.search;
      searchParameters.postcode = this.searchTextIsLocation;
      searchParameters.sortByReverse = false;
      searchParameters.latitude = this.latitude;
      searchParameters.longitude = this.longitude;
      searchParameters.sortBy = this.sortBy;
      searchParameters.distance = this.filters.distance;
      searchParameters.maxAveragePrice = this.filters.maxAveragePrice;
      searchParameters.minMaxRange = this.filters.minMaxRange;
      searchParameters.facilities = this.filters.facilities.filter(f => f.enabled).map((f) => f.property);
      searchParameters.tier = 2;
      return searchParameters;
    },

    isUsingLocation() {
      return this.latitude !== 0 && this.longitude !== 0 && this.latitude !== '0' && this.longitude !== '0';
    },

    placeholder() {
      if (this.searchTextIsLocation) return 'Search by location';
      if (this.isUsingLocation) return 'Using Current Location';
      return  'Search by club name';
    },

    totalClubsInFilter() {
      return this.clubListHelper.totalClubsInFilter;
    },

    showingMaxClubs() {
      return this.totalClubsInFilter <= this.index;
    },
    showingLiterallyAllClubs() {
      return this.clubListHelper.totalClubsInFilter === this.clubListHelper.totalClubs;
    },
  },

  watch: {
    async currentSearchParameters() {
      this.loading = true;
      await this.updateClubList();
      if(this.currentView === 'map'){
        await this.updateMapList();
        this.applyFiltersToMap = true;
      }
    },

    async applyFiltersToMap() {
      await this.updateMapList();
    },

    currentlyMapView() {
      this.setQueryParams();
    },

   searchTextIsLocation(value) {
      if (value){
        this.sortBy = "1"
      }
    },
  },

  created() {
    this.updateClubList = _.debounce(this.updateClubList, 600);

  },

  async mounted() {
    this.showFilters = !this.$isMobile.value;
    this.clubListHelper = services.club.clubListWithHelpers();
    this.getQueryParams();
    await this.getClubList();
  },

  methods: {
    setQuickSearch(quickSearch) {
      this.search = '';
      this.sortBy = quickSearch.sortBy;
    },

    async setCurrentView(value) {
      this.currentView = value;
      if(this.currentView === 'map') {
        await this.updateMapList();
      }
    },

    async updateMapList() {
      if (this.applyFiltersToMap) { 
        const search = this.currentSearchParameters;
        search.numClubsToReturn = 10000;
        this.clubsForMap = await this.clubListHelper.getClubs(search);
      }
      else {
        const search = new ClubListSearchParametersModel();
        search.numClubsToReturn = 10000;
        this.clubsForMap = await this.clubListHelper.getClubs(search);
      }
      this.mapClickedAtLeastOnce = true;
    },

    reset() {
      this.sortBy = '0';
      this.filters.distance = 100;
      this.filters.maxAveragePrice = 10;
      this.filters.minMaxRange = [0, 15];
      this.filters.facilities.forEach(f => f.enabled = false);
      this.search = '';
      this.index = 10;
    },

    getQueryParams() {
      if (this.$route.query.searchterm !== undefined && this.$route.query.searchterm !== null && this.$route.query.searchterm !== '') {
        this.search = this.$route.query.searchterm;
      }
      if (this.$route.query.location !== undefined && this.$route.query.location !== null && this.$route.query.location !== '') {
        this.location = this.$route.query.location;
      }
      if (this.$route.query.sortby !== undefined && this.$route.query.sortby !== null && this.$route.query.sortby !== '') {
        this.sortBy = this.$route.query.sortby;
      }
       if (this.$route.query.searchislocation !== undefined && this.$route.query.searchislocation !== null && this.$route.query.searchislocation !== '') {
        this.searchTextIsLocation = this.$route.query.searchislocation === "true" ? true : false;
      }
       if (this.$route.query.latitude !== undefined && this.$route.query.latitude !== null && this.$route.query.latitude !== '') {
        this.latitude = this.$route.query.latitude;
      }
      if (this.$route.query.longitude !== undefined && this.$route.query.longitude !== null && this.$route.query.longitude!== '') {
        this.longitude = this.$route.query.longitude;
      }
      if (this.$route.query.distance !== undefined && this.$route.query.distance!== null && this.$route.query.distance !== '') {
        this.filters.distance = parseInt(this.$route.query.distance, 10);
      } 
      if (this.$route.query.maxaverageprice !== undefined && this.$route.query.maxaverageprice !== null && this.$route.query.maxaverageprice !== '') {
        this.filters.maxAveragePrice = parseInt(this.$route.query.maxaverageprice,10);
      } 
      if (this.$route.query.minmaxrange !== undefined && this.$route.query.minmaxrange !== null && this.$route.query.minmaxrange !== '') {
        this.filters.minMaxRange = [parseInt(this.$route.query.minmaxrange[0], 10), parseInt(this.$route.query.minmaxrange[1], 10)] ;
      }
       if (this.$route.query.clubindex !== undefined && this.$route.query.clubindex !== null && this.$route.query.clubindex !== ''  && this.$route.query.clubindex !== '0') {
        this.index = parseInt(this.$route.query.clubindex, 10); 
      }
       if (this.$route.query.showmap !== undefined && this.$route.query.showmap !== null && this.$route.query.showmap !== '') {
        if(this.$route.query.showmap === "true") this.setCurrentView('map');
      }
    },

    setQueryParams() {
      const queryObject = {};
      queryObject.searchterm = this.search;
      queryObject.location = this.location;
      queryObject.sortby = this.sortBy;
      queryObject.searchislocation = this.searchTextIsLocation;
      queryObject.latitude = this.latitude;
      queryObject.longitude = this.longitude;
      queryObject.distance = this.filters.distance;
      queryObject.maxaverageprice = this.filters.maxAveragePrice;
      queryObject.minmaxrange = this.filters.minMaxRange;
      queryObject.showmap = this.currentlyMapView;
      queryObject.clubindex = this.index;
      // if(this.$route.name === 'clubs') {
      //   this.$router.replace({name: 'clubs', query: queryObject});
      // }
    },

    checkForPermission() {
      let vm = this;
      cordova.plugins.diagnostic.isLocationEnabled(function(enabled){
          if(!enabled){
            if(!this.$isIOS){
              // Doesn't work for ios
              if(confirm("Location is currently disabled. Would you like to open the Settings page to enable?")){
                cordova.plugins.diagnostic.switchToLocationSettings();
              }
            } else {
              alert('Location is currently disabled. Please enable to use this feature');
            }
          } else {
            cordova.plugins.diagnostic.isLocationAvailable(function(enabled){
                if(!enabled){
                  alert('Permission for your location is required to use this feature')
                  cordova.plugins.diagnostic.requestLocationAuthorization();
                } else {
                  vm.locationLoading = true;
                  vm.watchID = navigator.geolocation.watchPosition(vm.setLocation, vm.locationError, { maximumAge: 3000, timeout: 5000, enableHighAccuracy: true });
                }
              }
            );
          }
        }
      );
    },

    useLocation() {
      if(this.$isMobileApp) {
        this.checkForPermission();
      } else {
        this.searchTextIsLocation = false; 
        this.search ='';
        this.locationLoading = true;
        this.watchID = navigator.geolocation.watchPosition(this.setLocation, this.locationError, { maximumAge: 3000, timeout: 5000, enableHighAccuracy: true });
      }
    },

    useHomeClubLocation() {
      this.locationLoading = true;
      this.latitude = 0;
      this.longitude = 0;
      this.getClubList();
    },

    setLocation(location) {
      this.latitude = location.coords.latitude;
      this.longitude = location.coords.longitude;
      this.sortBy = '1'
      this.getClubList();
      navigator.geolocation.clearWatch(this.watchID);
    },

    locationError(error) {
      console.log(error)
      alert(error.message);
    },

    scrollTop(){
      document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    },

   clubScrollListener() {
      let clubList = document.getElementById('clubList');
      let goingUp = false;
      if(clubList !== undefined && clubList !== null) {
        if (this.scrollPosition > document.documentElement.scrollTop) {
          goingUp = true;
        }
        this.scrollPosition = document.documentElement.scrollTop;
        if(!this.addingMoreClubs && !goingUp) {
          if (((document.documentElement.scrollHeight - document.documentElement.scrollTop) - 200) < document.documentElement.clientHeight)
          {
            if (this.clubs.length > 0 && !this.showingMaxClubs) {
              this.addingMoreClubs = true;
              this.index += 10;
            }
          }
        }
      } else {
        // this removes the clubScroll bit without removing all scroll events
        document.removeEventListener('scroll', this.clubScrollListener);
      }
   },

    addScrollListener() {
      document.addEventListener('scroll', this.clubScrollListener);
    },

    async getClubList(){
      await this.updateClubList();
      if (!this.scrollListenerAdded) {
        setTimeout(() => {
          this.addScrollListener();
          this.scrollListenerAdded = true;
        }, 1000);
      } else {
        setTimeout(() => {
          document.getElementById('clubList').scroll({ top: 0, behavior: 'smooth' });
        }, 1000);
      }
    },


    async updateClubList(){
      const vm = this;
      await this.setQueryParams();
      const clubsReturned = await this.clubListHelper.getClubs(this.currentSearchParameters);
      this.clubs = [];
      clubsReturned.forEach((item) => {
        if (item.MyHomeClub) {
          vm.homeClub = item;
        }

        vm.clubs.push(item);
        this.locationLoading = false;
      });
       vm.loading = false;
      this.addingMoreClubs = false;
    },

    navigate(club){
      if(!club.ClosedToVisitors || club.MyHomeClub){
        //this.$router.push('/booking/clubs/' + club.Id);
        //this.$router.push(`/booking/clubs/${club.Id}/${this.courses.filter(c => c.FacilityType === 0)[0].Id}?Date=${new moment().toISOString()}&Players=1&Juniors=0`)
      }
    },

    unfocus(){
      document.activeElement.blur();
    },

    increaseIndex(){
      this.index += 10;
    },

    resetAndScroll() {
      document.documentElement.scrollTo({ top: 0, behavior: 'auto' });
      this.reset();
    },

    getBackground(){
      return 'https://members.playmore.golf/Images/clubsplash.jpg';
      if(this.$isStandard){
        return this.coverUrl;
      }

      return this.currentTheme.cover2;
    },

    toggleFacility(index){
      this.filters.facilities[index].enabled = !this.filters.facilities[index].enabled;
    },
  },
};
</script>
